import React, { useState } from "react";
import Pfl from './components/Pfl';
import Sdc from './components/Sdc';
import Checkscan from './components/Checkscan';
import Button from "@mui/material/Button"
import Face2face from "./components/Face2face";
import Console from "./components/Console";
import Instinct from "./components/Instinct";
import Bos from "./components/Bos";
import Webhook from "./components/Webhook";
import SdkBackend from "./components/SdkbackendKit";
import { Grid } from '@mui/material'
import './Apicontainer.css'
import { Typography } from "@mui/material";


export default function Apicontainer() {
    const [sharedState, setSharedState] = useState({ sdc: null, checkScan: null, pfl: null, face2face: null, console: null, instinct: null, bos: null, webhook: null, sdkbackend: null })
    const [sharedState1, setSharedState1] = useState({ sdc: null, checkScan: null, pfl: null, face2face: null, console: null, instinct: null, bos: null, webhook: null, sdkbackend: null })
    
    function submit() {
        setSharedState({ sdc: 'sdcData', checkScan: 'checkScanData', pfl: 'pflData', face2face: "face2faceData", console: "consoleData", instinct: "instinctData", bos: "bosData", webhook: "webhookData", sdkbackend: 'sdkbackendData' })
    }

    function submit1() {
        setSharedState1({ sdc: 'sdcData', checkScan: 'checkScanData', pfl: 'pflData', face2face: "face2faceData", console: "consoleData", instinct: "instinctData", bos: "bosData", webhook: "webhookData", sdkbackend: 'sdkbackendData' })
    }

    function refreshPage() {
        window.location.reload();
    }

    return (<>
        <Grid className="container" container spacing={0.5}>
            <Grid item xs={6}>
                <Console data={sharedState.console} data1={sharedState1.console} />
            </Grid>
            <Grid item xs={6}>
                <Bos data={sharedState.bos} data1={sharedState1.bos}/>
            </Grid>
            <Grid item xs={6}>
                <Face2face data={sharedState.face2face} data1={sharedState1.face2face}/>
            </Grid>
            <Grid item xs={6}>
                <Webhook data={sharedState.webhook} data1={sharedState1.webhook}/>
            </Grid>
            <Grid item xs={6}>
                <Instinct data={sharedState.instinct} data1={sharedState1.instinct}/>
            </Grid>
            <Grid item xs={6}>
                <SdkBackend data={sharedState.sdkbackend} data1={sharedState1.sdkbackend}/>
            </Grid>
            <Grid item xs={6}>
                <Pfl data={sharedState.pfl} data1={sharedState1.pfl}/>
            </Grid>
            <Grid item xs={6}>
                <Sdc data={sharedState.sdc} data1={sharedState1.sdc}/>
            </Grid>
            <Grid item xs={6}>
                <Checkscan data={sharedState.checkScan} data1={sharedState1.checkScan}/>
            </Grid>
            <Grid item xs={6}>
            <Button onClick={submit1} variant="contained" sx={{
                    p: 5,
                    marginTop: 20,
                    fontSize: 19,
                    marginRight: 3,
                    fontWeight: 'bold',
                    borderRadius: '35px',
                }}>Ui/UX</Button>
                <Button onClick={submit} variant="contained" sx={{
                    p: 5,
                    marginTop: 20,
                    fontSize: 19,
                    fontWeight: 'bold',
                    borderRadius: '35px',
                }}>Start</Button>
                <Button onClick={refreshPage} variant="contained" sx={{
                    p: 5,
                    marginTop: 20,
                    marginLeft: 3,
                    fontSize: 19,
                    fontWeight: 'bold',
                    borderRadius: '35px',
                }}>Reset</Button>
            </Grid>
        </Grid>
        <Typography sx={{
            marginTop: 13,
            color: '#98AFC7',
        }} align='left' variant='h4'>Created by: Alon Levy</Typography>
        </>
    )
}
